/**
 * Prefills the Inquire form when arriving from an artwork's Inquire link:
 * ?artwork=<title>&artist=<name>&show=<exhibition>. Fills the message (only
 * if empty) and a hidden Artwork field, then puts the cursor in Name.
 */
(() => {
  const form = document.querySelector('[data-inquire-form]');
  if (!form) return;
  const params = new URLSearchParams(window.location.search);
  const artwork = params.get('artwork');
  if (!artwork) return;

  const artist = params.get('artist');
  const show = params.get('show');
  let subject = `“${artwork}”`;
  if (artist) subject += ` by ${artist}`;
  if (show) subject += `, from ${show}`;

  const hidden = form.querySelector('[data-inquire-artwork]');
  if (hidden) hidden.value = subject;

  const message = form.querySelector('textarea[name="contact[body]"]');
  if (message && !message.value.trim()) {
    const template = form.dataset.messageTemplate || '{{ artwork }}';
    message.value = template.replace('{{ artwork }}', subject);
  }

  const name = form.querySelector('input[name="contact[name]"]');
  if (name && !form.querySelector('.form-status')) name.focus({ preventScroll: true });
})();
